import { Component, OnInit, Input } from '@angular/core';

export interface TituloSubtituloCorFundoData {
  title: string;
  subtitle: string;
  bgColor: string;
}

@Component({
  selector: 'fcp-titulo-subtitulo-cor-fundo',
  templateUrl: './titulo-subtitulo-cor-fundo.component.html',
  styleUrls: ['./titulo-subtitulo-cor-fundo.component.scss']
})
export class TituloSubtituloCorFundoComponent implements OnInit {

  @Input() public tituloSubtituloCorFundo: TituloSubtituloCorFundoData;

  constructor() { }

  ngOnInit(): void {
  }

}
